import React, { useEffect, useRef, useState } from "react";

import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import { FroalaRichText } from "../../util/FroalaRichtext";
import { useAppSelector, useAppDispatch } from "../../../redux/hooks";
import FroalaEditorView from "react-froala-wysiwyg/FroalaEditorView";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { PropertyManagerTable } from "./PropertyManagerTable";
import { JvPartnerTable } from "./JvPartnerTable";

import {
  AutosaveDelay,
  CommentKey,
  CommentSectionName,
  Category,
  Key,
} from "../../../constant";
import { saveDapCommentData } from "../../../redux/slices/saveCommentSlice";
import {
  updateDapCommentData,
  DapComment,
} from "../../../redux/slices/updateDapCommentSlice";
import { updatedJvStatus, updateJvPartner, updatekeyProvisionData, updatePropertyManager } from "redux/slices/updateDataSlice";
import { get } from "http";
import { getKeyProvisions, getJvPartnerData, getPropertyManagerData } from "redux/slices/keyProvisionEditFormSlice";
import { Skeleton } from "@mui/material";

// for grid
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "left",
  color: theme.palette.text.secondary,
}));

export const KeyProvision = (props) => {

  var dispatch = useAppDispatch();
  const CommentStatus = useAppSelector((state) => state.dapComments);
  const dapData = useAppSelector((state) => state.summary.dapData);
  const assetPlanId = useAppSelector(
    (state) => state.getAssetPlanId.assetPlanId
  );

  const keyProvisionsData = useAppSelector(
    (state) => state.updateData.keyProvisionData
  ) || {
    planningAdviser: { firmName: "", keyContacts: "", email: "", riskRating: undefined },
    buildingContractors: { firmName: "", keyContacts: "", email: "", riskRating: undefined },
    leasingAgents: { firmName: "", keyContacts: "", email: "", riskRating: undefined },
    insuranceCompanyDetails: { firmName: "", keyContacts: "", email: "", riskRating: undefined },
    jvPartner: [{ firmName: "", keyContacts: "", email: "", riskRating: undefined }],
    holdingStructure: { specialPurposeVehicle: "", holdingCompany: "" }
  };
  const updatedPropertyManagerData = useAppSelector(
    (state) => state.updateData.propertyManagerData
  );
  const updatedJvPartnerData = useAppSelector(
    (state) => state.updateData.JVsData
  );
  const propertyManagerLoading = useAppSelector((state) => state.keyProvisionEditForm.propertyManagerLoading);
  const jvPartnerLoading = useAppSelector((state) => state.keyProvisionEditForm.jvPartnerLoading);
  const keyProvisionsLoading = useAppSelector((state) => state.keyProvisionEditForm.loading);

  useEffect(() => {
    if (assetPlanId) {
      dispatch(getJvPartnerData(assetPlanId));
      dispatch(getPropertyManagerData(assetPlanId));
      dispatch(getKeyProvisions(assetPlanId));

    }
  }, [assetPlanId, dispatch])

  const handlekeyContactsChange = (partner, field, value) => {
    const updatedData = {
      ...keyProvisionsData,
      [partner === "planningAdvisor" ? "planningAdviser" :
        partner === "insuranceCompany" ? "insuranceCompanyDetails" : partner]: {
        ...keyProvisionsData[partner === "planningAdvisor" ? "planningAdviser" :
          partner === "insuranceCompany" ? "insuranceCompanyDetails" : partner],
        [field]: value
      }
    };
    dispatch(updatekeyProvisionData(updatedData));
  };

  const handleHoldingStructureChange = (field, value) => {
    const updatedData = {
      ...keyProvisionsData,
      holdingStructure: {
        ...keyProvisionsData.holdingStructure,
        [field]: value
      }
    };
    dispatch(updatekeyProvisionData(updatedData));
  };

  const handlePropertyManagerChange = (field, value) => {
    const data = {
      ...updatedPropertyManagerData,
      [field]: value
    };

    dispatch(updatePropertyManager(data));
  };

  const handleJvPartnerDataChange = (index: number, field: string, value: any) => {
    const newJvPartnerData = [...updatedJvPartnerData];
    newJvPartnerData[index] = {
      ...newJvPartnerData[index],
      [field]: value
    };
    dispatch(updateJvPartner(newJvPartnerData));
  };


  const comments = useAppSelector((state) => state.dapComments?.data).find(
    (x) => x.commentKey.toLowerCase() === CommentKey.KEYPROVISIONS.toLowerCase()
  );

  const handleCommentsChange = (newValue: string) => {
    const updatedcomment: DapComment = {
      id: comments ? comments.id : 0,
      commentKey: comments ? comments.commentKey : CommentKey.KEYPROVISIONS,
      commentText: newValue || "",
      sectionName: CommentSectionName.KEYPROVISIONS,
      assetPlanId: assetPlanId,
    };
    dispatch(updateDapCommentData(updatedcomment));
    dispatch(saveDapCommentData(updatedcomment));
  };


  const addJvPartner = () => {
    const newJvPartnerData = [...updatedJvPartnerData, {}];
    dispatch(updateJvPartner(newJvPartnerData));
  };

  const removeJvPartner = (index: number) => {
    const filteredJvPartnerData = updatedJvPartnerData.filter((_, i) => i !== index);
    if (filteredJvPartnerData.length == 0) {
      dispatch(updatedJvStatus("delete"))
    }
    dispatch(updateJvPartner(filteredJvPartnerData));
  };

  const keyProvisionsComment = useAppSelector(
    (state) => state.dapComments?.data
  );

  const mangementComment_date =
    keyProvisionsComment.find(
      (x) =>
        x.commentKey.toLowerCase() ===
        CommentKey.MANAGEMENTAGREEMENT_DATE.toLowerCase()
    )?.commentText || "";
  const mangementComment_fee =
    keyProvisionsComment.find(
      (x) =>
        x.commentKey.toLowerCase() ===
        CommentKey.MANAGEMENTAGREEMENT_FEE.toLowerCase()
    )?.commentText || "";
  const mangementComment_otherFee =
    keyProvisionsComment.find(
      (x) =>
        x.commentKey.toLowerCase() ===
        CommentKey.MANAGEMENTAGREEMENT_OTHERFEE.toLowerCase()
    )?.commentText || "";
  const leasebroker_name =
    keyProvisionsComment.find(
      (x) =>
        x.commentKey.toLowerCase() === CommentKey.LEASEBROKER_NAME.toLowerCase()
    )?.commentText || "";
  const leasebroker_fee =
    keyProvisionsComment.find(
      (x) =>
        x.commentKey.toLowerCase() === CommentKey.LEASEBROKER_FEE.toLowerCase()
    )?.commentText || "";
  const leasebroker_otherfee =
    keyProvisionsComment.find(
      (x) =>
        x.commentKey.toLowerCase() ===
        CommentKey.LEASEBROKER_OTHERFEE.toLowerCase()
    )?.commentText || "";
  const jvagreement_KeyDecision =
    keyProvisionsComment.find(
      (x) =>
        x.commentKey.toLowerCase() ===
        CommentKey.JVAGREEMENT_KEYDECISION.toLowerCase()
    )?.commentText || "";
  const jvagreement_liquidProvision =
    keyProvisionsComment.find(
      (x) =>
        x.commentKey.toLowerCase() ===
        CommentKey.JVAGREEMENT_LIQUIDITYPROVISION.toLowerCase()
    )?.commentText || "";
  const jvagreement_fee =
    keyProvisionsComment.find(
      (x) =>
        x.commentKey.toLowerCase() === CommentKey.JVAGREEMENT_FEE.toLowerCase()
    )?.commentText || "";
  const jvagreement_Keyprovision =
    keyProvisionsComment.find(
      (x) =>
        x.commentKey.toLowerCase() ===
        CommentKey.JVAGREEMENT_KEYPROVISION.toLowerCase()
    )?.commentText || "";


  const handleCommentChange = (model: any, commentKey: any) => {

    const getCurrentComment = keyProvisionsComment.find(
      (x) => x.commentKey.toLowerCase() === commentKey.toLowerCase()
    );
    const updatedcomment: DapComment = {
      id: getCurrentComment ? getCurrentComment.id : 0,
      commentKey: getCurrentComment ? getCurrentComment.commentKey : commentKey,
      commentText: model || "",
      sectionName: CommentSectionName.KEYPROVISIONS,
      assetPlanId: assetPlanId,
    };

    dispatch(updateDapCommentData(updatedcomment));
    dispatch(saveDapCommentData(updatedcomment));

  };

  return (
    <div>
      <Box sx={{ flexGrow: 1 }} className="summary-form">
        <div className="tab-heading text-center">
          <h3 className="heading">Key Provisions</h3>
        </div>
        {keyProvisionsLoading ? (
          <Skeleton variant="rounded" width="100%" height={200} animation="wave" />
        ) : (
          <TableContainer
            component={Paper}
            sx={{
              maxWidth: '100%',
              marginBottom: 3,
              boxShadow: 1,
              '& .MuiTable-root': {
                borderCollapse: 'collapse',
                minWidth: '100%',
              },
              '& .MuiTableCell-root': {
                border: '1px solid rgba(224, 224, 224, 1)',
                padding: '4px 16px',
                fontSize: '0.875rem',
                height: '40px'
              },
              '& .MuiTableRow-root': {
                height: '40px'
              }
            }}
          >
            <div style={{ display: 'flex', alignItems: 'baseline', marginBottom: '5px' }}>
              <h3 style={{ marginTop: '0px' }} >Key Contacts</h3>
              <span style={{
                fontSize: '0.7rem',
                fontWeight: '400',
                fontStyle: 'italic',
                color: '#666',
                backgroundColor: '#f5f5f5',
                padding: '2px 6px',
                borderRadius: '3px',
                marginLeft: '8px',
              }}>
                EMEA/APAC
              </span>
            </div>
            <Table
              aria-label="key contacts table"
              size="small"
              sx={{ '& .MuiTableCell-sizeSmall': { padding: '2px 16px' } }}
            >

              <TableHead>
                <TableRow sx={{ backgroundColor: '#253746' }}>
                  <TableCell sx={{ color: 'white' }}></TableCell>
                  <TableCell sx={{ color: 'white' }}>Firm Name</TableCell>
                  <TableCell sx={{ color: 'white' }}>Key Contact</TableCell>
                  <TableCell sx={{ color: 'white' }}>Email</TableCell>
                  <TableCell sx={{ color: 'white' }}>Risk rating</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell component="th" scope="row">Planning Advisor</TableCell>
                  <TableCell>
                    {props?.mode === "edit" ? (
                      <TextField
                        fullWidth
                        size="small"
                        margin="dense"
                        InputProps={{
                          style: {
                            margin: "0px",
                            fontFamily:
                              "Roboto, Helvetica, Arial, sans-serif",
                            fontSize: "0.875rem",
                            color: "rgba(0, 0, 0, 0.6)",
                          },
                        }}
                        value={keyProvisionsData.planningAdviser.firmName || ''}
                        onChange={(e) => handlekeyContactsChange("planningAdvisor", "firmName", e.target.value)}
                        sx={{ '& .MuiInputBase-root': { height: '32px' } }}
                      />
                    ) : (
                      keyProvisionsData.planningAdviser.firmName
                    )}
                  </TableCell>
                  <TableCell>
                    {props?.mode === "edit" ? (
                      <TextField
                        fullWidth
                        size="small"
                        margin="dense"
                        InputProps={{
                          style: {
                            margin: "0px",
                            fontFamily:
                              "Roboto, Helvetica, Arial, sans-serif",
                            fontSize: "0.875rem",
                            color: "rgba(0, 0, 0, 0.6)",
                          },
                        }}
                        value={keyProvisionsData.planningAdviser.keyContacts || ''}
                        onChange={(e) => handlekeyContactsChange("planningAdvisor", "keyContacts", e.target.value)}
                        sx={{ '& .MuiInputBase-root': { height: '32px' } }}
                      />
                    ) : (
                      keyProvisionsData.planningAdviser.keyContacts
                    )}
                  </TableCell>
                  <TableCell>
                    {props?.mode === "edit" ? (
                      <TextField
                        fullWidth
                        size="small"
                        margin="dense"
                        InputProps={{
                          style: {
                            margin: "0px",
                            fontFamily:
                              "Roboto, Helvetica, Arial, sans-serif",
                            fontSize: "0.875rem",
                            color: "rgba(0, 0, 0, 0.6)",
                          },
                        }}
                        value={keyProvisionsData.planningAdviser.email || ''}
                        onChange={(e) => handlekeyContactsChange("planningAdvisor", "email", e.target.value)}
                        sx={{ '& .MuiInputBase-root': { height: '32px' } }}
                      />
                    ) : (
                      keyProvisionsData.planningAdviser.email
                    )}
                  </TableCell>
                  <TableCell>
                    {props?.mode === "edit" ? (
                      <FormControl fullWidth>
                        <Select
                          value={keyProvisionsData.planningAdviser.riskRating || ''}
                          onChange={(e) => handlekeyContactsChange("planningAdvisor", "riskRating", Number(e.target.value))}
                          size="small"
                          sx={{
                            height: '32px',
                            '& .MuiSelect-select': {
                              margin: "0px",
                              fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                              fontSize: "0.875rem",
                              color: "rgba(0, 0, 0, 0.6)",
                              padding: '4px 14px',
                            },
                            '& .MuiOutlinedInput-notchedOutline': {
                              borderColor: 'rgba(0, 0, 0, 0.23)',
                            },
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                              borderColor: 'rgba(0, 0, 0, 0.87)',
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                              borderColor: '#1976d2',
                            }
                          }}
                        >
                          <MenuItem value={1}>1</MenuItem>
                          <MenuItem value={2}>2</MenuItem>
                          <MenuItem value={3}>3</MenuItem>
                          <MenuItem value={4}>4</MenuItem>
                          <MenuItem value={5}>5</MenuItem>
                        </Select>
                      </FormControl>
                    ) : (
                      keyProvisionsData.planningAdviser.riskRating
                    )}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">Building Contractors</TableCell>
                  <TableCell>
                    {props?.mode === "edit" ? (
                      <TextField
                        fullWidth
                        size="small"
                        margin="dense"
                        InputProps={{
                          style: {
                            margin: "0px",
                            fontFamily:
                              "Roboto, Helvetica, Arial, sans-serif",
                            fontSize: "0.875rem",
                            color: "rgba(0, 0, 0, 0.6)",
                          },
                        }}
                        value={keyProvisionsData.buildingContractors.firmName}
                        onChange={(e) => handlekeyContactsChange("buildingContractors", "firmName", e.target.value)}
                        sx={{ '& .MuiInputBase-root': { height: '32px' } }}
                      />
                    ) : (
                      keyProvisionsData.buildingContractors.firmName
                    )}
                  </TableCell>
                  <TableCell>
                    {props?.mode === "edit" ? (
                      <TextField
                        fullWidth
                        size="small"
                        margin="dense"
                        InputProps={{
                          style: {
                            margin: "0px",
                            fontFamily:
                              "Roboto, Helvetica, Arial, sans-serif",
                            fontSize: "0.875rem",
                            color: "rgba(0, 0, 0, 0.6)",
                          },
                        }}
                        value={keyProvisionsData.buildingContractors.keyContacts}
                        onChange={(e) => handlekeyContactsChange("buildingContractors", "keyContacts", e.target.value)}
                        sx={{ '& .MuiInputBase-root': { height: '32px' } }}
                      />
                    ) : (
                      keyProvisionsData.buildingContractors.keyContacts
                    )}
                  </TableCell>
                  <TableCell>
                    {props?.mode === "edit" ? (
                      <TextField
                        fullWidth
                        size="small"
                        margin="dense"
                        InputProps={{
                          style: {
                            margin: "0px",
                            fontFamily:
                              "Roboto, Helvetica, Arial, sans-serif",
                            fontSize: "0.875rem",
                            color: "rgba(0, 0, 0, 0.6)",
                          },
                        }}
                        value={keyProvisionsData.buildingContractors.email}
                        onChange={(e) => handlekeyContactsChange("buildingContractors", "email", e.target.value)}
                        sx={{ '& .MuiInputBase-root': { height: '32px' } }}
                      />
                    ) : (
                      keyProvisionsData.buildingContractors.email
                    )}
                  </TableCell>
                  <TableCell>
                    {props?.mode === "edit" ? (
                      <FormControl fullWidth>
                        <Select
                          value={keyProvisionsData.buildingContractors.riskRating || ''}
                          onChange={(e) => handlekeyContactsChange("buildingContractors", "riskRating", Number(e.target.value))}
                          size="small"
                          sx={{
                            height: '32px',
                            '& .MuiSelect-select': {
                              margin: "0px",
                              fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                              fontSize: "0.875rem",
                              color: "rgba(0, 0, 0, 0.6)",
                              padding: '4px 14px',
                            },
                            '& .MuiOutlinedInput-notchedOutline': {
                              borderColor: 'rgba(0, 0, 0, 0.23)',
                            },
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                              borderColor: 'rgba(0, 0, 0, 0.87)',
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                              borderColor: '#1976d2',
                            }
                          }}
                        >
                          <MenuItem value={1}>1</MenuItem>
                          <MenuItem value={2}>2</MenuItem>
                          <MenuItem value={3}>3</MenuItem>
                          <MenuItem value={4}>4</MenuItem>
                          <MenuItem value={5}>5</MenuItem>
                        </Select>
                      </FormControl>
                    ) : (
                      keyProvisionsData.buildingContractors.riskRating
                    )}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">Leasing agent(s)</TableCell>
                  <TableCell>
                    {props?.mode === "edit" ? (
                      <TextField
                        fullWidth
                        size="small"
                        margin="dense"
                        InputProps={{
                          style: {
                            margin: "0px",
                            fontFamily:
                              "Roboto, Helvetica, Arial, sans-serif",
                            fontSize: "0.875rem",
                            color: "rgba(0, 0, 0, 0.6)",
                          },
                        }}
                        value={keyProvisionsData.leasingAgents.firmName}
                        onChange={(e) => handlekeyContactsChange("leasingAgents", "firmName", e.target.value)}
                        sx={{ '& .MuiInputBase-root': { height: '32px' } }}
                      />
                    ) : (
                      keyProvisionsData.leasingAgents.firmName
                    )}
                  </TableCell>
                  <TableCell>
                    {props?.mode === "edit" ? (
                      <TextField
                        fullWidth
                        size="small"
                        margin="dense"
                        InputProps={{
                          style: {
                            margin: "0px",
                            fontFamily:
                              "Roboto, Helvetica, Arial, sans-serif",
                            fontSize: "0.875rem",
                            color: "rgba(0, 0, 0, 0.6)",
                          },
                        }}
                        value={keyProvisionsData.leasingAgents.keyContacts}
                        onChange={(e) => handlekeyContactsChange("leasingAgents", "keyContacts", e.target.value)}
                        sx={{ '& .MuiInputBase-root': { height: '32px' } }}
                      />
                    ) : (
                      keyProvisionsData.leasingAgents.keyContacts
                    )}
                  </TableCell>
                  <TableCell>
                    {props?.mode === "edit" ? (
                      <TextField
                        fullWidth
                        size="small"
                        margin="dense"
                        InputProps={{
                          style: {
                            margin: "0px",
                            fontFamily:
                              "Roboto, Helvetica, Arial, sans-serif",
                            fontSize: "0.875rem",
                            color: "rgba(0, 0, 0, 0.6)",
                          },
                        }}
                        value={keyProvisionsData.leasingAgents.email}
                        onChange={(e) => handlekeyContactsChange("leasingAgents", "email", e.target.value)}
                        sx={{ '& .MuiInputBase-root': { height: '32px' } }}
                      />
                    ) : (
                      keyProvisionsData.leasingAgents.email
                    )}
                  </TableCell>
                  <TableCell>
                    {props?.mode === "edit" ? (
                      <FormControl fullWidth>
                        <Select
                          value={keyProvisionsData.leasingAgents.riskRating || ''}
                          onChange={(e) => handlekeyContactsChange("leasingAgents", "riskRating", Number(e.target.value))}
                          size="small"
                          sx={{
                            height: '32px',
                            '& .MuiSelect-select': {
                              margin: "0px",
                              fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                              fontSize: "0.875rem",
                              color: "rgba(0, 0, 0, 0.6)",
                              padding: '4px 14px',
                            },
                            '& .MuiOutlinedInput-notchedOutline': {
                              borderColor: 'rgba(0, 0, 0, 0.23)',
                            },
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                              borderColor: 'rgba(0, 0, 0, 0.87)',
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                              borderColor: '#1976d2',
                            }
                          }}
                        >
                          <MenuItem value={1}>1</MenuItem>
                          <MenuItem value={2}>2</MenuItem>
                          <MenuItem value={3}>3</MenuItem>
                          <MenuItem value={4}>4</MenuItem>
                          <MenuItem value={5}>5</MenuItem>
                        </Select>
                      </FormControl>
                    ) : (
                      keyProvisionsData.leasingAgents.riskRating
                    )}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">Insurance company details</TableCell>
                  <TableCell>
                    {props?.mode === "edit" ? (
                      <TextField
                        fullWidth
                        size="small"
                        margin="dense"
                        InputProps={{
                          style: {
                            margin: "0px",
                            fontFamily:
                              "Roboto, Helvetica, Arial, sans-serif",
                            fontSize: "0.875rem",
                            color: "rgba(0, 0, 0, 0.6)",
                          },
                        }}
                        value={keyProvisionsData.insuranceCompanyDetails.firmName}
                        onChange={(e) => handlekeyContactsChange("insuranceCompany", "firmName", e.target.value)}
                        sx={{ '& .MuiInputBase-root': { height: '32px' } }}
                      />
                    ) : (
                      keyProvisionsData.insuranceCompanyDetails.firmName
                    )}
                  </TableCell>
                  <TableCell>
                    {props?.mode === "edit" ? (
                      <TextField
                        fullWidth
                        size="small"
                        margin="dense"
                        InputProps={{
                          style: {
                            margin: "0px",
                            fontFamily:
                              "Roboto, Helvetica, Arial, sans-serif",
                            fontSize: "0.875rem",
                            color: "rgba(0, 0, 0, 0.6)",
                          },
                        }}
                        value={keyProvisionsData.insuranceCompanyDetails.keyContacts}
                        onChange={(e) => handlekeyContactsChange("insuranceCompany", "keyContacts", e.target.value)}
                        sx={{ '& .MuiInputBase-root': { height: '32px' } }}
                      />
                    ) : (
                      keyProvisionsData.insuranceCompanyDetails.keyContacts
                    )}
                  </TableCell>
                  <TableCell>
                    {props?.mode === "edit" ? (
                      <TextField
                        fullWidth
                        size="small"
                        margin="dense"
                        InputProps={{
                          style: {
                            margin: "0px",
                            fontFamily:
                              "Roboto, Helvetica, Arial, sans-serif",
                            fontSize: "0.875rem",
                            color: "rgba(0, 0, 0, 0.6)",
                          },
                        }}
                        value={keyProvisionsData.insuranceCompanyDetails.email}
                        onChange={(e) => handlekeyContactsChange("insuranceCompany", "email", e.target.value)}
                        sx={{ '& .MuiInputBase-root': { height: '32px' } }}
                      />
                    ) : (
                      keyProvisionsData.insuranceCompanyDetails.email
                    )}
                  </TableCell>
                  <TableCell>
                    {props?.mode === "edit" ? (
                      <FormControl fullWidth>
                        <Select
                          value={keyProvisionsData.insuranceCompanyDetails.riskRating || ''}
                          onChange={(e) => handlekeyContactsChange("insuranceCompany", "riskRating", Number(e.target.value))}
                          size="small"
                          sx={{
                            height: '32px',
                            '& .MuiSelect-select': {
                              margin: "0px",
                              fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                              fontSize: "0.875rem",
                              color: "rgba(0, 0, 0, 0.6)",
                              padding: '4px 14px',
                            },
                            '& .MuiOutlinedInput-notchedOutline': {
                              borderColor: 'rgba(0, 0, 0, 0.23)',
                            },
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                              borderColor: 'rgba(0, 0, 0, 0.87)',
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                              borderColor: '#1976d2',
                            }
                          }}
                        >
                          <MenuItem value={1}>1</MenuItem>
                          <MenuItem value={2}>2</MenuItem>
                          <MenuItem value={3}>3</MenuItem>
                          <MenuItem value={4}>4</MenuItem>
                          <MenuItem value={5}>5</MenuItem>
                        </Select>
                      </FormControl>
                    ) : (
                      keyProvisionsData.insuranceCompanyDetails.riskRating
                    )}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        )}
        {propertyManagerLoading ? (
          <Skeleton variant="rounded" width="100%" height={200} animation="wave" />
        ) : (
          <PropertyManagerTable
            mode={props?.mode}
            propertyManagerData={updatedPropertyManagerData}
            handlePropertyManagerChange={handlePropertyManagerChange}
          />
        )}

        {/* {(dapData?.ownershipType === "Unconsolidated JV") &&
          (jvPartnerLoading ? (
            <Skeleton variant="rounded" width="100%" height={200} animation="wave" />
          ) : ( */}
        <JvPartnerTable
          mode={props?.mode}
          jvPartnerData={updatedJvPartnerData}
          handleJvPartnerDataChange={handleJvPartnerDataChange}
          addJvPartner={addJvPartner}
          removeJvPartner={removeJvPartner}
        />
        {/* ))
        } */}
        {keyProvisionsLoading ? (
          <Skeleton variant="rounded" width="100%" height={200} animation="wave" />
        ) : (
          <TableContainer
            component={Paper}
            sx={{
              maxWidth: '100%',
              marginBottom: 3,
              boxShadow: 1,
              '& .MuiTable-root': {
                borderCollapse: 'collapse',
                minWidth: '100%',
              },
              '& .MuiTableCell-root': {
                border: '1px solid rgba(224, 224, 224, 1)',
                padding: '4px 16px',
                fontSize: '0.875rem',
                height: '40px'
              },
              '& .MuiTableRow-root': {
                height: '40px'
              }
            }}
          >
            <div style={{ display: 'flex', alignItems: 'baseline', marginBottom: '5px' }}>
              <h3 style={{ marginTop: '0px' }}>Holding Structure</h3>
              <span style={{
                fontSize: '0.7rem',
                fontWeight: '400',
                fontStyle: 'italic',
                color: '#666',
                backgroundColor: '#f5f5f5',
                padding: '2px 6px',
                borderRadius: '3px',
                marginLeft: '8px'
              }}>
                EMEA/APAC
              </span>
            </div>
            <Table
              aria-label="holding structure table"
              size="small"
              sx={{ '& .MuiTableCell-sizeSmall': { padding: '2px 16px' } }}
            >
              <TableHead>
                <TableRow sx={{ backgroundColor: '#253746' }}>
                  <TableCell sx={{ color: 'white' }}>Structure Type</TableCell>
                  <TableCell sx={{ color: 'white' }}>Details</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell component="th" scope="row">Special purpose vehicle</TableCell>
                  <TableCell>
                    {props?.mode === "edit" ? (
                      <TextField
                        fullWidth
                        size="small"
                        margin="dense"
                        InputProps={{
                          style: {
                            margin: "0px",
                            fontFamily:
                              "Roboto, Helvetica, Arial, sans-serif",
                            fontSize: "0.875rem",
                            color: "rgba(0, 0, 0, 0.6)",
                          },
                        }}
                        value={keyProvisionsData.holdingStructure.specialPurposeVehicle}
                        onChange={(e) => handleHoldingStructureChange("specialPurposeVehicle", e.target.value)}
                        sx={{ '& .MuiInputBase-root': { height: '32px' } }}
                      />
                    ) : (
                      keyProvisionsData.holdingStructure.specialPurposeVehicle
                    )}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">Holding company</TableCell>
                  <TableCell>
                    {props?.mode === "edit" ? (
                      <TextField
                        fullWidth
                        size="small"
                        margin="dense"
                        InputProps={{
                          style: {
                            margin: "0px",
                            fontFamily:
                              "Roboto, Helvetica, Arial, sans-serif",
                            fontSize: "0.875rem",
                            color: "rgba(0, 0, 0, 0.6)",
                          },
                        }}
                        value={keyProvisionsData.holdingStructure.holdingCompany}
                        onChange={(e) => handleHoldingStructureChange("holdingCompany", e.target.value)}
                        sx={{ '& .MuiInputBase-root': { height: '32px' } }}
                      />
                    ) : (
                      keyProvisionsData.holdingStructure.holdingCompany
                    )}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        )}
        <h3 className="text-left sub-heading">Management Agreement</h3>
        {CommentStatus.loading ? (
          <Skeleton variant="rounded" width="100%" height={200} animation="wave" />
        ) : (
          <Grid container spacing={2}>
            {/* block1 */}
            <Grid item xs={12} md={4}>
              <Item>
                <h3 className="text-left">Name/ Parties/ Date</h3>
                <div className="grid-item-box">
                  {props?.mode === "edit" && (
                    <FroalaRichText
                      model={mangementComment_date}
                      handlesModelChange={(model: any) =>
                        handleCommentChange(
                          model,
                          CommentKey.MANAGEMENTAGREEMENT_DATE
                        )
                      }
                    />
                  )}
                  {(props?.mode === undefined || props?.mode === "view") && (
                    <FroalaEditorView model={mangementComment_date} />
                  )}
                </div>
              </Item>
            </Grid>

            <Grid item xs={12} md={4}>
              <Item>
                <h3 className="text-left">Management Fees</h3>
                <div className="grid-item-box">
                  {props?.mode === "edit" && (
                    <FroalaRichText
                      model={mangementComment_fee}
                      handlesModelChange={(model) =>
                        handleCommentChange(
                          model,
                          CommentKey.MANAGEMENTAGREEMENT_FEE
                        )
                      }
                    />
                  )}
                  {(props?.mode === undefined || props?.mode === "view") && (
                    <FroalaEditorView model={mangementComment_fee} />
                  )}
                </div>
              </Item>
            </Grid>

            <Grid item xs={12} md={4}>
              <Item>
                <h3 className="text-left">Other Fees</h3>
                <div className="grid-item-box">
                  {props?.mode === "edit" && (
                    <FroalaRichText
                      model={mangementComment_otherFee}
                      handlesModelChange={(model) =>
                        handleCommentChange(
                          model,
                          CommentKey.MANAGEMENTAGREEMENT_OTHERFEE
                        )
                      }
                    />
                  )}
                  {(props?.mode === undefined || props?.mode === "view") && (
                    <FroalaEditorView model={mangementComment_otherFee} />
                  )}
                </div>
              </Item>
            </Grid>
          </Grid>
        )}

        <h3 className="text-left sub-heading">Leasing Broker</h3>
        {CommentStatus.loading ? (
          <Skeleton variant="rounded" width="100%" height={200} animation="wave" />
        ) : (
          <Grid container spacing={2}>
            {/* block1 */}
            <Grid item xs={12} md={4}>
              <Item>
                <h3 className="text-left">Name</h3>
                <div className="grid-item-box">
                  {props?.mode === "edit" && (
                    <FroalaRichText
                      model={leasebroker_name}
                      handlesModelChange={(model) =>
                        handleCommentChange(model, CommentKey.LEASEBROKER_NAME)
                      }
                    />
                  )}
                  {(props?.mode === undefined || props?.mode === "view") && (
                    <FroalaEditorView model={leasebroker_name} />
                  )}
                </div>
              </Item>
            </Grid>

            <Grid item xs={12} md={4}>
              <Item>
                <h3 className="text-left">Management Fees</h3>
                <div className="grid-item-box">
                  {props?.mode === "edit" && (
                    <FroalaRichText
                      model={leasebroker_fee}
                      handlesModelChange={(model) =>
                        handleCommentChange(model, CommentKey.LEASEBROKER_FEE)
                      }
                    />
                  )}
                  {(props?.mode === undefined || props?.mode === "view") && (
                    <FroalaEditorView model={leasebroker_fee} />
                  )}
                </div>
              </Item>
            </Grid>

            <Grid item xs={12} md={4}>
              <Item>
                <h3 className="text-left">Other Fees</h3>
                <div className="grid-item-box">
                  {props?.mode === "edit" && (
                    <FroalaRichText
                      model={leasebroker_otherfee}
                      handlesModelChange={(model) =>
                        handleCommentChange(
                          model,
                          CommentKey.LEASEBROKER_OTHERFEE
                        )
                      }
                    />
                  )}
                  {(props?.mode === undefined || props?.mode === "view") && (
                    <FroalaEditorView model={leasebroker_otherfee} />
                  )}
                </div>
              </Item>
            </Grid>
          </Grid>
        )}


        <h3 className="text-left sub-heading">JV Agreement</h3>
        {CommentStatus.loading ? (
          <Skeleton variant="rounded" width="100%" height={200} animation="wave" />
        ) : (
          <Grid container spacing={2}>
            {/* block1 */}
            <Grid item xs={12} md={3}>
              <Item>
                <h3 className="text-left">Key Major Decisions</h3>
                <div className="grid-item-box">
                  {props?.mode === "edit" && (
                    <FroalaRichText
                      model={jvagreement_KeyDecision}
                      handlesModelChange={(model) =>
                        handleCommentChange(
                          model,
                          CommentKey.JVAGREEMENT_KEYDECISION
                        )
                      }
                    />
                  )}
                  {(props?.mode === undefined || props?.mode === "view") && (
                    <FroalaEditorView model={jvagreement_KeyDecision} />
                  )}
                </div>
              </Item>
            </Grid>

            <Grid item xs={12} md={3}>
              <Item>
                <h3 className="text-left">Fees</h3>
                <div className="grid-item-box">
                  {props?.mode === "edit" && (
                    <FroalaRichText
                      model={jvagreement_fee}
                      handlesModelChange={(model) =>
                        handleCommentChange(model, CommentKey.JVAGREEMENT_FEE)
                      }
                    />
                  )}
                  {(props?.mode === undefined || props?.mode === "view") && (
                    <FroalaEditorView model={jvagreement_fee} />
                  )}
                </div>
              </Item>
            </Grid>

            <Grid item xs={12} md={3}>
              <Item>
                <h3 className="text-left">Liquidity Provisions</h3>
                <div className="grid-item-box">
                  {props?.mode === "edit" && (
                    <FroalaRichText
                      model={jvagreement_liquidProvision}
                      handlesModelChange={(model) =>
                        handleCommentChange(
                          model,
                          CommentKey.JVAGREEMENT_LIQUIDITYPROVISION
                        )
                      }
                    />
                  )}
                  {(props?.mode === undefined || props?.mode === "view") && (
                    <FroalaEditorView model={jvagreement_liquidProvision} />
                  )}
                </div>
              </Item>
            </Grid>

            <Grid item xs={12} md={3}>
              <Item>
                <h3 className="text-left">Other Key Provisions</h3>
                <div className="grid-item-box">
                  {props?.mode === "edit" && (
                    <FroalaRichText
                      model={jvagreement_Keyprovision}
                      handlesModelChange={(model) =>
                        handleCommentChange(
                          model,
                          CommentKey.JVAGREEMENT_KEYPROVISION
                        )
                      }
                    />
                  )}
                  {(props?.mode === undefined || props?.mode === "view") && (
                    <FroalaEditorView model={jvagreement_Keyprovision} />
                  )}
                </div>
              </Item>
            </Grid>
          </Grid>
        )}
      </Box>


      <form className="m-20 lease-form">
        <fieldset>
          <legend className="lease-title">Comments</legend>
          <>
            {props?.mode === "edit" && (
              <FroalaRichText
                model={comments?.commentText || ""}
                handlesModelChange={handleCommentsChange}
              />
            )}

            {(props?.mode === undefined || props?.mode === "view") && (
              <FroalaEditorView model={comments?.commentText || ""} />
            )}
          </>
        </fieldset>
      </form>
    </div>
  );
};